/**
 * Unlike displayMomentumScore, there is no legacy lane. `persona_signal_score`
 * is computed per request for the tenant asking; a row without it was fetched
 * through a path that has not been scored, and should read as "no score"
 * rather than borrowing a hand-typed number.
 *
 * Do not read `persona_activity_score_change`.
 */
export function displayPersonaScore(row) {
  const computed = Number(row?.persona_signal_score);
  return row?.persona_signal_score != null && !Number.isNaN(computed) ? computed : null;
}

/** Reporting surfaces — |score| ≥ 2.0. Signed negative passes. */
export const PERSONA_REPORTING_FLOOR = 2.0;

/** Acting surfaces — signed score ≥ 3.0. A −4 never qualifies. */
export const PERSONA_ACTING_FLOOR = 3.0;

export function isPersonaReportingScore(score) {
  const n = Number(score);
  return score != null && score !== '' && !Number.isNaN(n) && Math.abs(n) >= PERSONA_REPORTING_FLOOR;
}

export function isPersonaActingScore(score) {
  const n = Number(score);
  return score != null && score !== '' && !Number.isNaN(n) && n >= PERSONA_ACTING_FLOOR;
}

/** Signed −5…+5 display. Negative is a warning, not a missing plus. */
export function formatPersonaScore(n) {
  if (n == null || n === '') return '';
  const v = Number(n);
  if (Number.isNaN(v)) return '';
  return v > 0 ? `+${v.toFixed(1)}` : v.toFixed(1);
}
